module.exports = __webpack_public_path__ + "excelLogo.png";